import logger from '~/services/logger';
import { getIsFirstCell, getIsLastCell } from './getters';

/**
 * Triggers the scroll action based on the direction and the circularCondition flag
 * @param ref - The horizontal list container ref, this is the most parent container with a ref attached to it
 * @param cellRef - The cell ref
 * @param gutter - The component horizontal gutter
 * @param feedEntriesLength - The feed entries length
 * @param circularCondition - The circular condition that is true when circular scoll is enabled OR autoscroll is enabled with loop
 * @param scrollAction - The scroll action function that accepts direction as parameter
 * @param direction - The direction of the scroll action
 * @param isInitialLoad - The initial load flag
 * @param componentMaxWidth - The component max width
 * @param paddingLeft - The padding left of the component
 * @param performCircularReset - Optional callback to perform circular reset using centralized logic
 */
export function triggerScrollAction({
  ref,
  cellRef,
  gutter,
  feedEntriesLength,
  circularCondition,
  scrollAction,
  direction,
  isInitialLoad,
  componentMaxWidth,
  performCircularReset,
}: {
  ref: any;
  cellRef: any;
  gutter: number | undefined;
  feedEntriesLength: number;
  circularCondition: boolean;
  scrollAction: (direction: 'left' | 'right') => void;
  direction: 'left' | 'right';
  isInitialLoad?: boolean;
  componentMaxWidth: number;
  performCircularReset: (direction: 'left' | 'right') => void;
}) {
  if (direction !== 'left' && direction !== 'right') {
    logger.info(`Error: Invalid direction: ${direction}`);
    return;
  }

  if (!circularCondition) {
    scrollAction(direction);
    return;
  }

  if (!gutter) gutter = 0;

  const isLastCell: boolean = getIsLastCell({
    ref,
    cellRef,
    feedEntriesLength,
    gutter,
    componentMaxWidth,
  });

  if (!isLastCell && direction === 'right') {
    scrollAction('right');
    return;
  }

  const isFirstCell: boolean = getIsFirstCell({
    ref,
    cellRef,
    gutter,
    componentMaxWidth,
  });

  if (!isFirstCell && direction === 'left') {
    scrollAction('left');
    return;
  }

  performCircularReset(direction);

  if (isInitialLoad) return;

  scrollAction(direction);
}
